export default [
  { id: "I", description: "Instrumental" },
  { id: "V", description: "Visual" },
  { id: "Y", description: "Inicialmente instrumental" },
  { id: "Z", description: "Inicialmente visual" },
];
